<template>
  <v-container
      fill-height fluid>
    <v-row
        align="center"
        justify="center">
      <v-col
          xs="12" sm="7" md="3">
        <v-alert
            type="success"
        >
          ارسال اثر با موفقیت صورت گرفت.
          <br>
          کد پیگیری شما:
          {{ submission.uuid }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Success",
  computed: {
    ...mapState({
      submission: state => state.Submit.submission,

    }),
  },
}
</script>

<style scoped>

</style>